import PropTypes from "prop-types";

/**
 * PropTypes for FloatWindow component
 *
 * @property {Ref} triggerRef - Reference to the trigger element
 * @property {ReactNode} children - Content to render inside window
 * @property {string} [className] - Optional CSS classes
 * @property {string} [placement] - Placement direction (left, right, or auto)
 */
export const floatWindowPropTypes = {
  triggerRef: PropTypes.shape({ current: PropTypes.instanceOf(Element) }),
  children: PropTypes.node,
  className: PropTypes.string,
  placement: PropTypes.oneOf(["left", "right", ""]),
};
